import { Box, Stack, Typography } from "@mui/material";

export type AssessmentPageStepperNode = {
  id: string;
  label?: string;
  isMajor?: boolean;
};

type AssessmentPageStepperProps = {
  nodes: AssessmentPageStepperNode[];
  activeIndex: number;
};

export function AssessmentPageStepper({
  nodes,
  activeIndex,
}: AssessmentPageStepperProps) {
  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={0}
      sx={{ width: "fit-content", minHeight: 56 }}
    >
      {nodes.map((node, index) => {
        const isCompleted = index < activeIndex;
        const isActive = index === activeIndex;
        const isMajor = Boolean(node.isMajor);
        const size = isMajor ? 40 : 16;

        return (
          <Stack key={node.id} direction="row" alignItems="center" spacing={0}>
            <Box
              sx={(theme) => ({
                width: size,
                height: size,
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
                zIndex: 1,
                fontSize: isMajor ? 20 : 0,
                fontWeight: 700,
                lineHeight: 1,
                color:
                  isCompleted || isActive
                    ? theme.palette.common.white
                    : theme.palette.text.secondary,
                backgroundColor:
                  isCompleted || isActive
                    ? theme.palette.primary.main
                    : theme.palette.grey[300],
              })}
            >
              {isMajor ? (
                isCompleted ? (
                  <Typography
                    component="span"
                    sx={(theme) => ({
                      fontSize: 18,
                      fontWeight: 700,
                      lineHeight: 1,
                      color: theme.palette.common.white,
                    })}
                  >
                    ✓
                  </Typography>
                ) : (
                  node.label
                )
              ) : null}
            </Box>
            {index < nodes.length - 1 ? (
              <Box sx={{ width: 44, ml: "-3px", mr: "-3px" }}>
                <Box
                  sx={(theme) => ({
                    width: "100%",
                    height: 8,
                    backgroundColor:
                      index < activeIndex
                        ? theme.palette.primary.main
                        : theme.palette.grey[300],
                  })}
                />
              </Box>
            ) : null}
          </Stack>
        );
      })}
    </Stack>
  );
}
